import { render, staticRenderFns } from "./register-dialog.vue?vue&type=template&id=544d8b40&"
import script from "./register-dialog.vue?vue&type=script&lang=js&"
export * from "./register-dialog.vue?vue&type=script&lang=js&"
import style0 from "./register-dialog.vue?vue&type=style&index=0&id=544d8b40&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports